import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

import { useWorkspaces } from "..";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { BaseOrganization, Organization } from "@/types/organizations";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";
import { displayErrorToast } from "@/utils/toast";

export const useCreateOrganization = () => {
  const userToken = useAuth()?.userToken ?? "";
  const queryClient = useQueryClient();
  const { refetch } = useWorkspaces();
  const navigate = useNavigate();

  return useMutation(
    (body: BaseOrganization): Promise<Organization> =>
      fetch(ENDPOINTS.organizations, {
        method: "POST",
        headers: jsonAuthHeaders(userToken),
        body: JSON.stringify(body),
      }).then(handleResponse),
    {
      onSuccess: async newOrganization => {
        queryClient.invalidateQueries([ENDPOINTS.organizations]);
        const { data } = await refetch();
        const foundWorkspace = data?.workspaces.find(w => w.organization_id === newOrganization.id);
        if (foundWorkspace) {
          navigate(`/workspace/${foundWorkspace.id}`);
        }
      },
      onError: (error: string) => {
        displayErrorToast(error);
      },
    },
  );
};
